var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.269 8.198h-.105l-2.661.005h-.127a.797.797 0 0 0 .063 1.59h2.848a.805.805 0 0 0 .731-.8.803.803 0 0 0-.75-.795Zm-3.856-2.47 1.916-1.913.1-.104a.803.803 0 0 0-.05-1.081.797.797 0 0 0-1.094-.032l-.073.073-1.876 1.885-.09.09a.797.797 0 0 0 .045 1.077.79.79 0 0 0 1.122.004ZM9.007 0a.8.8 0 0 0-.8.75v.104l.01 2.657v.127a.8.8 0 0 0 .794.731c.44 0 .795-.354.795-.794V.73a.801.801 0 0 0-.8-.731ZM5.732 4.597 3.82 2.689l-.1-.105A.801.801 0 0 0 2.603 3.73l.072.073L4.56 5.673l.091.09a.792.792 0 0 0 1.076-.045.783.783 0 0 0 .005-1.121Zm-2.09 5.191a.793.793 0 0 0-.064-1.585H.732A.8.8 0 0 0 .75 9.797h.105l2.662-.009h.127Zm.964 2.48L2.689 14.18l-.1.1a.803.803 0 0 0 1.145 1.117l.072-.077 1.876-1.885.09-.09a.795.795 0 0 0-1.167-1.076Zm5.191 2.09a.793.793 0 0 0-1.585.063v2.848a.8.8 0 0 0 1.599-.018v-.105L9.8 14.49v-.132h-.004Zm5.541-.164-1.89-1.872-.09-.09a.798.798 0 0 0-1.08.045.795.795 0 0 0 0 1.122l.004.005 1.912 1.907.104.1a.801.801 0 0 0 1.117-1.14l-.077-.077Z",
    fill: "#fff",
    style: {
      fill: "#f9f9f9"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.b894894d1e491e1387b8b4ea3ff319fa.svg";
export { ForwardRef as ReactComponent };